export enum CreateDropoffStep {
    CREATOR = 0,
    INFOS,
    LOCATION,
    CONTACT,
    PHOTOS,
    SUCCESS
}

export function createDropoffStepTitle(step: CreateDropoffStep, isDetailsScreen: boolean, isMobile: boolean): string | undefined {
    switch (step) {
        case CreateDropoffStep.CREATOR:
            return 'SubmitDropoff.title.creator'
        case CreateDropoffStep.INFOS:
            if (isMobile) {
                return undefined
            }
            return isDetailsScreen ? 'SubmitDropoff.infos.wastes.title' : 'SubmitDropoff.title.infos' 
        case CreateDropoffStep.LOCATION:
            return 'SubmitDropoff.title.location'
        case CreateDropoffStep.CONTACT:
            return isDetailsScreen ? 'SubmitDropoff.mobile.title.opening.hours' : 'SubmitDropoff.title.contact'
        case CreateDropoffStep.PHOTOS:
            return 'SubmitDropoff.title.photos'
        case CreateDropoffStep.SUCCESS:
            return 'SubmitDropoff.title.success'
    }
}

export function createDropoffMobileHeaderTitle(step: CreateDropoffStep, isDetailsScreen: boolean): string {
    if (isDetailsScreen) {
        switch (step) {
            case CreateDropoffStep.INFOS:
                return 'SubmitDropoff.mobile.title.wastes'
            case CreateDropoffStep.CONTACT:
                return 'SubmitDropoff.mobile.title.opening.hours'
        }
    }

    return 'SubmitDropoff.mobile.title'
}

export function createDropoffStepPreviousButtonTitle(step: CreateDropoffStep): string | undefined {
    switch (step) {
        case CreateDropoffStep.CREATOR:
            return 'SubmitDropoff.navigation.cancel'
        case CreateDropoffStep.INFOS:
            return 'SubmitDropoff.navigation.previous' 
        case CreateDropoffStep.LOCATION:
            return 'SubmitDropoff.navigation.previous'
        case CreateDropoffStep.CONTACT:
            return 'SubmitDropoff.navigation.previous'
        case CreateDropoffStep.PHOTOS:
            return 'SubmitDropoff.navigation.previous'
        case CreateDropoffStep.SUCCESS:
            return undefined
    }
}

export function createDropoffStepNextButtonTitle(step: CreateDropoffStep): string {
    switch (step) {
        case CreateDropoffStep.CREATOR:
            return 'SubmitDropoff.navigation.next'
        case CreateDropoffStep.INFOS:
            return 'SubmitDropoff.navigation.next' 
        case CreateDropoffStep.LOCATION:
            return 'SubmitDropoff.navigation.next'
        case CreateDropoffStep.CONTACT:
            return 'SubmitDropoff.navigation.next'
        case CreateDropoffStep.PHOTOS:
            return 'SubmitDropoff.navigation.next'
        case CreateDropoffStep.SUCCESS:
            return 'SubmitDropoff.navigation.success'
    }
}
